import request from '@/utils/request';
import { Message } from 'element-ui';
import {SettingMer} from '@/utils/settingMer';

/**
 * 获取sts临时身份
 */
export const getDirectSts = async () => {
  return request({
    isFile: true,
    // url: `${SettingMer.apiPubliclyURL}cos/getSts`,
    // 新接口，不需要授权
    url: `${SettingMer.apiPubliclyURL}cos/getStsForFrontTemp`,
    method: 'get',
  });
};

/**
 * 获取上传key
 */
export const getGenKey = () => {
  return request({
    isFile: true,
    // url: `${SettingMer.apiPubliclyURL}cos/genKey`,
    // 新接口，不需要授权
    url: `${SettingMer.apiPubliclyURL}cos/genKeyForFrontTemp`,
    method: 'get',
  });
};

/**
 * 直传
 * @param
 * @constructor
 */
export const directFile = (file, url, formData) => {
  const from = new FormData();
  for (let key in formData) {
    from.append(key, formData[key]);
  }
  from.append('file', file);
  return request({
    isFile: true,
    url: url,
    method: 'POST',
    data: from,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

/**
 * 文件导出
 * @param {*} url 请求路径
 * @param {*} data 筛选参数
 * @param {*} fileName 导出文件名
 * @param {*} requestName 请求名称 otherRequest(0元模块、实物礼物模块) -or- request（用户列表模块）
 * @returns
 */

export const _EXPORTFILE = (url, requestName, data, fileName) => {
  requestName({
    method: 'post',
    url,
    data,
    responseType: 'blob',
    isFileStream: true,
    timeout: 120000,
  })
    .then((res) => {
      const blob = new Blob([res.data]);
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${fileName}.xlsx`;
      link.click();
      Message.success('导出成功');
    })
    .catch((err) => {
      Message.error('导出失败,请稍后重试');
      console.log(err);
    });
};
